import {
  CoreType,
  Kpi as KpiT,
  KpiQuery as KpiQueryT,
  KpiResult as KpiResultT,
  KpiResponse as KpiResponseT
} from '../shared/Contracts'

export type Ticket = {
  id: string
  timestamp: string
  realmId: string
  ticketId: string
  categoryId: string
  typeId: string
  status: TicketStatus
  spaceId: string | null
  levelId: string | null
  constructionId: string | null
  complexId: string | null
}

export type FilterQuery = {
  from: string
  to: string
  entityType?: CoreType
  entityIds?: string[]
  ticketTypeIds?: string[]
  ticketStatuses?: TicketStatus[]
}

export type KpiType = 'SUM_TICKETS'
export type DetailSplitBy = 'TYPE'

export type Kpi = KpiT<KpiType, {}>
export type KpiQuery = KpiQueryT<FilterQuery, KpiType, {}>
export type KpiDetailQuery = KpiQueryT<FilterQuery, KpiType, {}, DetailSplitBy>
export type KpiResult = KpiResultT<KpiType>
export type KpiResponse = KpiResponseT<FilterQuery, KpiType>

export type TimeSeriesValue = {
  date: string
  numberOfTickets: number | null
}

export type TimeSeriesResponse = {
  values: TimeSeriesValue[]
}

export const TICKET_STATUSES = [
  'NOT_IN_PROGRESS',
  'ON_GOING',
  'ON_HOLD',
  'FINISHED',
  'CANCELLED',
  'UNKNOWN'
] as const

export type TicketStatus = typeof TICKET_STATUSES[number]

export const ticketStatuses = {
  NOT_IN_PROGRESS: {
    en: 'Not In Progress',
    sv: 'Ej påbörjad'
  },
  ON_GOING: {
    en: 'On Going',
    sv: 'Pågående'
  },
  ON_HOLD: {
    en: 'On Hold',
    sv: 'Pausad'
  },
  FINISHED: {
    en: 'Finished',
    sv: 'Avslutad'
  },
  CANCELLED: {
    en: 'Cancelled',
    sv: 'Avbruten'
  },
  UNKNOWN: {
    en: 'Unknown',
    sv: 'Okänd'
  }
}

export const BADGE_COLORS: Record<TicketStatus, string> = {
  NOT_IN_PROGRESS: '#FFD6E7',
  CANCELLED: '#FFD6E7',
  FINISHED: '#C2F3EE',
  UNKNOWN: '#E0E0E0',
  ON_GOING: '#BAE7FF',
  ON_HOLD: '#FFD6E7'
}
